import * as BlipSdk from 'blip-sdk';
import * as WebSocketTransport from 'lime-transport-websocket';
export class BotClientService {
    static $inject = ['CurrentApplicationService', 'TenantService', 'MESSAGINGHUBDOMAIN', 'MESSAGINGHUBWEBSOCKETHOSTNAME', 'MESSAGINGHUBWEBSOCKETPORT', 'MESSAGINGHUBWEBSOCKETSCHEME', 'MESSAGINGHUBWEBSOCKETHOSTNAMETENANT'];
    constructor(CurrentApplicationService, TenantService, MESSAGINGHUBDOMAIN, MESSAGINGHUBWEBSOCKETHOSTNAME, MESSAGINGHUBWEBSOCKETPORT, MESSAGINGHUBWEBSOCKETSCHEME, MESSAGINGHUBWEBSOCKETHOSTNAMETENANT) {
        this.CurrentApplicationService = CurrentApplicationService;
        this.TenantService = TenantService;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
        this.MESSAGINGHUBWEBSOCKETHOSTNAME = MESSAGINGHUBWEBSOCKETHOSTNAME;
        this.MESSAGINGHUBWEBSOCKETPORT = MESSAGINGHUBWEBSOCKETPORT;
        this.MESSAGINGHUBWEBSOCKETSCHEME = MESSAGINGHUBWEBSOCKETSCHEME;
        this.MESSAGINGHUBWEBSOCKETHOSTNAMETENANT = MESSAGINGHUBWEBSOCKETHOSTNAMETENANT;
    }
    async build() {
        if (!this.application) {
            this.application = await this.CurrentApplicationService.fetchApplication();
        }
        const messagingHubWebsocketHostname = this.TenantService.addTenantPrefixToUrl(this.MESSAGINGHUBWEBSOCKETHOSTNAMETENANT, this.application?.tenantId, this.MESSAGINGHUBWEBSOCKETHOSTNAME);
        return new BlipSdk.ClientBuilder()
            .withIdentifier(this.application.shortName)
            .withInstance('blipportal')
            .withIssuer('blip.ai')
            .withEcho(true)
            .withNotifyConsumed(false)
            .withDomain(this.MESSAGINGHUBDOMAIN)
            .withHostName(messagingHubWebsocketHostname)
            .withPort(this.MESSAGINGHUBWEBSOCKETPORT)
            .withScheme(this.MESSAGINGHUBWEBSOCKETSCHEME)
            .withTransportFactory(() => new WebSocketTransport())
            .withAccessKey(this.application.accessKey)
            .build();
    }
    async customBuild(app) {
        const messagingHubWebsocketHostname = this.TenantService.addTenantPrefixToUrl(this.MESSAGINGHUBWEBSOCKETHOSTNAMETENANT, app?.tenantId, this.MESSAGINGHUBWEBSOCKETHOSTNAME);
        return new BlipSdk.ClientBuilder()
            .withIdentifier(app.shortName)
            .withInstance('blipportal')
            .withIssuer('blip.ai')
            .withEcho(true)
            .withNotifyConsumed(false)
            .withDomain(this.MESSAGINGHUBDOMAIN)
            .withHostName(messagingHubWebsocketHostname)
            .withPort(this.MESSAGINGHUBWEBSOCKETPORT)
            .withScheme(this.MESSAGINGHUBWEBSOCKETSCHEME)
            .withTransportFactory(() => new WebSocketTransport())
            .withAccessKey(app.accessKey)
            .build();
    }
}
BotClientService.$inject = ['CurrentApplicationService', 'TenantService', 'MESSAGINGHUBDOMAIN', 'MESSAGINGHUBWEBSOCKETHOSTNAME', 'MESSAGINGHUBWEBSOCKETPORT', 'MESSAGINGHUBWEBSOCKETSCHEME', 'MESSAGINGHUBWEBSOCKETHOSTNAMETENANT'];
